import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import ChatWidget from '../apps/chat';
// Set a type for the global $ats (at least the parts we use)
declare const $ats: {
  KEY: { USER_COOKIE: string };
};
// Get the user PIN from the local cookie. Right now we are using the old $ats
// code since it still works, but this should be converted to a React aware
// library

const pin = Cookies.get($ats.KEY.USER_COOKIE);
const { theme, chatSystem, chatHubUrl, chatApiKey, chatBotName, isDev, isOurApp } =
  document.querySelector('body').dataset;

Modal.setAppElement('#chatContainer');
ReactDOM.render(
  <ChatWidget
    pin={pin}
    apiKey={chatApiKey}
    url={chatHubUrl}
    theme={theme}
    botName={chatBotName}
    hideOpener
    proactive={chatSystem === 'enabled'}
    isOurApp={isOurApp === 'true'}
  />,
  document.getElementById('chatContainer'),
);
